"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'accountGrade.list.title': 'Price Packages',
};
